import MD5 from 'crypto-js/md5';
import { LoginAdapter, SignUpParams } from '@ow/shared/login';
import { useUserProfile } from '../../../context/user-profile-context';
import useLoginValidators from '@ow/shared/login/hooks/use-login-validators';
import { kRecaptchaWidgetId } from '../constants';

// -----------------------------------------------------------------------------
// Builds the LoginAdapter the shared login UI consumes from the website's own
// profile context and validators. Passwords are hashed here (the website backend
// expects MD5) before hitting the profile API. Translation, analytics and legal
// links are not login-specific and are passed to <LoginSignupForm> as props.
export const useWebsiteLoginAdapter = (): LoginAdapter => {
  const profile = useUserProfile();
  const validators = useLoginValidators();

  return {
    currentUser: profile.currentUser as any,
    loginStateChangedEvent: profile.loginStateChangedEvent,
    isUnverified: (user) => !!(user as any)?.profile?.unverified,

    performOverwolfLogin: (email, password) =>
      profile.performOverwolfLogin(email, MD5(password).toString()),
    performOverwolfSignUp: (params: SignUpParams) =>
      profile.performOverwolfSignUp({
        ...params,
        password: MD5(params.password).toString(),
      }),
    performSocialLogin: (network) => profile.performSocialLogin(network as any),
    resetPassword: (email) => profile.resetPassword(email),
    cancelAccountDeletion: () => profile.cancelAccountDeletion(),
    setToken: (token) => profile.setToken(token),
    getAndSetProfile: () => profile.getAndSetProfile() as any,
    logout: () => profile.logout(),
    resendVerification: (email) => profile.resendVerification(email),

    validateUsername: validators.validateUsername,
    validateEmail: validators.validateEmail,
    validatePassword: validators.validatePassword,

    recaptchaSiteKey: kRecaptchaWidgetId,
    assetBaseUrl: '',
  };
};
